<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'Alimento',
}

</script>



// WEBPACK FOOTER //
// src/components/alimento/Alimento.vue